import { withQuestionnaireFuncs } from 'Context/WithQuestionnaireAnswer';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getTimestampFromString, moment } from 'Helpers/DateTime';
import Input from 'Components/UI/BehavioralFormElement/Text/Date';
import { noop } from 'Helpers/PropTypes';
import { withHousehold } from 'Context/HouseholdContext';
import { makeHideable } from '../Hideable';
import './index.css';
import { ContextIndex } from './FieldList';
import withViewContext from './withViewContext';

class Date extends Component {
  constructor(props) {
    super(props);
    const {
      apiResponse: {
        attributes: { value: dateString, isReadonly },
      },
    } = props;
    const value = dateString ? getTimestampFromString(dateString) : null;

    this.state = {
      value,
      isReadonly: isReadonly === 'true',
      isDone: false,
    };

    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    const {
      householdId,
      answerKey,
      getQuestionnaireAnswer,
      getIndexedQuestionnaireAnswer,
    } = this.props;
    const index = this.context;

    let promise;
    if (index > -1) {
      promise = getIndexedQuestionnaireAnswer(householdId, answerKey, index);
    } else {
      promise = getQuestionnaireAnswer(householdId, answerKey);
    }

    return promise
      .then((res) => {
        const {
          props: { name, onChange },
        } = this;
        const value = res.attributes.value ? moment(res.attributes.value).format('YYYY-MM-DD') : null;
        onChange(name, value);
        this.setState({ value: getTimestampFromString(res.attributes.value), isReadonly: res.attributes.isReadonly === 'true' });
      })
      .finally(() => this.setState({ isDone: true }));
  }

  onChange(timestamp) {
    const {
      householdId, uploadValue, answerKey, onChange,
    } = this.props;
    const index = this.context;
    const value = timestamp ? moment(timestamp).format('YYYY-MM-DD') : null;
    this.setState(
      { value },
      () => {
        uploadValue(householdId, answerKey, {
          attributes: {
            value: value || '',
            index,
          },
        });
      },
      onChange(answerKey, value),
    );
  }

  render() {
    const {
      name,
      placeholder,
      label,
      dropdownClassName,
      displayInLocalTime,
      ...rest
    } = this.props;
    const { value, isReadonly, isDone } = this.state;

    if (!isDone) {
      return null;
    }

    return (
      <div className="questionnaire-input">
        <Input
          {...rest}
          disabled={isReadonly}
          value={
            value && !displayInLocalTime
              ? moment(value)
                .utc()
                .format('YYYY-MM-DD')
              : value
          }
          label={label || placeholder}
          onChange={(_, val) => {
            this.onChange(val);
          }}
          name={name}
          placeholder={placeholder}
          dropdownClassName={dropdownClassName}
        />
      </div>
    );
  }
}

Date.propTypes = {
  name: PropTypes.string.isRequired,
  uploadValue: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
  label: PropTypes.string,
  dropdownClassName: PropTypes.string,
  answerKey: PropTypes.string.isRequired,
  householdId: PropTypes.number.isRequired,
  apiResponse: PropTypes.instanceOf(Object),
  onChange: PropTypes.func,
  displayInLocalTime: PropTypes.bool,
  getQuestionnaireAnswer: PropTypes.func.isRequired,
  getIndexedQuestionnaireAnswer: PropTypes.func.isRequired,
};

Date.defaultProps = {
  apiResponse: { attributes: {} },
  onChange: noop,
  label: '',
  dropdownClassName: '',
  displayInLocalTime: true,
};

Date.contextType = ContextIndex;

const DateInput = withHousehold(withQuestionnaireFuncs(withViewContext(Date)));

export default makeHideable(DateInput);
